import InterfaceRiwayat from "../apiInterface/InterfaceRiwayat";
import ErrorAlert from "@/utility/ErrorAlert";

class DataRiwayat {
  async getDataRiwayatRm(rm,expand) {
    let dt: any;
    await InterfaceRiwayat.getRiwayatByRm(rm,expand)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Riwayat Pasien");
        // if (dt["status"] == 422) {
        //     dt = e.response.data.errors;
        // } else {
        //     dt = {
        //         data: dt,
        //         status: dt["status"],
        //         err: "ERR " + e.response.status + " : " + e.response.data.message
        //     };
        //     // dt = e.response
        // }
        // console.log("kosong", dt);
      });
    return dt;
  }
}
export default new DataRiwayat();
